import { HttpClient, HttpHandler, HttpXhrBackend, HttpHeaders, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Injector, APP_INITIALIZER, NgModule } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { OverlayContainer } from '@angular/cdk/overlay';
import { _isTestEnvironment } from '@angular/cdk/platform';

class EventConstants {
    static DASF_JWT_TOKEN = 'pershingJWT';
    static JWT_TOKEN_NAME = 'pershingAuthToken';
    static DASF_STATUS = 'status';
    static DASF_JWT_URL = '/websso/cmp/authentication/jwt';
    static DASF_KEEPALIVE_URL = '/websso/cmp/keepalive';
    static DASF_JWT_REFRESH_URL = '/websso/cmp/refresh';
    static DASF_LOGOUT_URL = '/websso/cmp/logout';
}

/**
 * Models for domain context. The domain is the category(account, household, etc).
 * The value is the object that contains the appropriate information fields.
 */
class DomainContext {
    domain;
    value;
}
class AccountContextValue {
    accountNumber;
    accountName;
    ibd;
    off;
    ip;
    categoryCode;
    accountType;
    status;
    custodianCode;
    businessPurposeCode;
    internalIdentifier;
    isInternalCustody;
    hashValue;
    accessCategoryCd;
    shortName;
    constructor(accountNumber, accountName, ibd, off, ip, categoryCode, accountType, status, custodianCode, businessPurposeCode, internalIdentifier, isInternalCustody, hashValue, accessCategoryCd, shortName) {
        this.accountNumber = accountNumber;
        this.accountName = accountName;
        this.ibd = ibd;
        this.off = off;
        this.ip = ip;
        this.categoryCode = categoryCode;
        this.accountType = accountType;
        this.status = status;
        this.custodianCode = custodianCode;
        this.businessPurposeCode = businessPurposeCode;
        this.internalIdentifier = internalIdentifier;
        this.isInternalCustody = isInternalCustody;
        this.hashValue = hashValue;
        this.accessCategoryCd = accessCategoryCd;
        this.shortName = shortName;
    }
}
class GroupContextValue {
    groupId;
    groupDescription;
    groupSourceCode;
    numberOfAccounts;
    groupType;
    accessType;
    albridgeIndicator;
    internalIdentifier;
    brokerId;
    groupCreatorId;
    groupGUID;
    hashValue;
    constructor(groupId, groupDescription, groupSourceCode, numberOfAccounts, groupType, accessType, albridgeIndicator, internalIdentifier, brokerId, groupCreatorId, groupGUID, hashValue) {
        this.groupId = groupId;
        this.groupDescription = groupDescription;
        this.groupSourceCode = groupSourceCode;
        this.numberOfAccounts = numberOfAccounts;
        this.groupType = groupType;
        this.accessType = accessType;
        this.albridgeIndicator = albridgeIndicator;
        this.internalIdentifier = internalIdentifier;
        this.brokerId = brokerId;
        this.groupCreatorId = groupCreatorId;
        this.groupGUID = groupGUID;
        this.hashValue = hashValue;
    }
}

var nxiPackages = {
	"@pershing/nxi-ng-common": "2.0.25",
	"@pershing/nxi-ng-modern-alerts": "2.0.25",
	"@pershing/nxi-ng-verid": "2.0.25",
	"@pershing/nxi-ng-account": "2024.0918.0",
	"@pershing/nxi-ng-accountopening": "2024.0918.0",
	"@pershing/nxi-ng-account-transfer": "2024.0918.0",
	"@pershing/nxi-ng-balances": "2024.0918.0",
	"@pershing/nxi-ng-contentmanagement": "2024.0918.0",
	"@pershing/nxi-ng-digital-portfolio": "2024.0918.0",
	"@pershing/nxi-ng-display-settings": "2024.0918.0",
	"@pershing/nxi-ng-gainloss": "2024.0918.0",
	"@pershing/nxi-ng-history": "2024.0918.0",
	"@pershing/nxi-ng-holdings": "2024.0918.0",
	"@pershing/nxi-ng-interstitials": "2024.0918.0",
	"@pershing/nxi-ng-managed-accounts": "2024.0918.0",
	"@pershing/nxi-ng-modern-digital-auth": "2024.0918.0",
	"@pershing/nxi-ng-modern-miscellaneous": "2024.0918.0",
	"@pershing/nxi-ng-pcf": "2024.0918.0",
	"@pershing/nxi-ng-prelogin": "2024.0918.0",
	"@pershing/nxi-ng-rateboard": "2024.0918.0",
	"@pershing/nxi-ng-userregistration": "2024.0918.0",
	"@pershing/nxi-ng-valuation-over-time": "2024.0918.0",
	"@pershing/nxi-ng-wealthview": "2024.0918.0",
	"@pershing/nxi-ng-mod": "2024.0918.0",
	"@pershing/nxi-ng-modern-navigation": "2024.0918.0",
	"@pershing/nxi-portalcomponents": "2024.0918.0",
	"@pershing/nxi-ng-quotetoggle": "2024.0918.0",
	"@pershing/nxi-ng-shell": "2024.0918.0",
	"@pershing/nxi-pershing-export": "2024.0918.0",
	"@pershing/trading-common": "2024.10.53",
	"@pershing/exchange-agreement": "2024.10.53",
	"@pershing/edc-newdocuments": "2024.10.0",
	"@pershing/edc-newedelivery": "2024.10.0",
	"@pershing/edc-newshareholder": "2024.10.0",
	"@pershing/nxi-shared-doc": "2024.8.9",
	"@pershing/nds-icl": "1.20240904.0-SNAPSHOT",
	"@pershing/pbp-debitcard": "16.0.11-SNAPSHOT",
	"@pershing/nds-earnedincome": "26.0.8",
	"@pershing/nxp-rmd": "24.10.0-SNAPSHOT",
	"@pershing/nxi-login-mfe": "9.1.8-SNAPSHOT",
	"@pershing/nxi-login-app": "9.1.8-SNAPSHOT",
	"@pershing/nxi-self-registration": "1.0.0-SNAPSHOT",
	"@pershing/totp-app": "2.1.2-SNAPSHOT",
	"@pershing/pershing-f2": "14.1.0",
	"@pershing/edc-newdocumentlibrary": "2023.6.0",
	"@pershing/edc-newdocuments-downloadcenter": "2023.6.0",
	"@pershing/edc-newdocuments-view": "2023.6.0",
	"@pershing/amp-menu": "16.1.12",
	"@pershing/amp-ach": "16.1.12",
	"@pershing/amp-checks": "16.1.12"
};
var nxpPackages = {
	"@pershing/ibilling-ui": "0.0.26",
	"@pershing/nxp-messagecenter": "24.3.3",
	"@pershing/trading-equity-order-import-app": "2024.4.20",
	"@pershing/nds-comments": "14.0.13",
	"@pershing/ng-myrelationship": "14.0.12",
	"@pershing/ere-admin-ui": "5.3.0",
	"@pershing/nds-context-cards": "9.1.2",
	"@pershing/trading-options-app": "2024.4.20",
	"portal-aot-bundles": "14.2.3",
	"@pershing/ees-search": "9.5.7",
	"@pershing/login-app": "6.0.8",
	"@pershing/nxp-loiroa": "1.1.1",
	"@pershing/annuities-maintenance": "1.1.6",
	"@pershing/dashboard-components": "14.0.1",
	"@pershing/nxp-fisellbid": "1.0.0",
	"@pershing/doi-documents-view": "2024.02.16.6",
	"@pershing/nxp-resources": "2.1.6",
	"@pershing/nxp-fidtool": "14.0.2",
	"@pershing/delivery-management-landing": "5.2023.1",
	"@pershing/nxp-activity": "11.6.0",
	"@pershing/trading-mutualfund-app": "2024.4.20",
	"@pershing/ice-notify-center": "2.0.17",
	"@pershing/companionapps-config": "14.5.12",
	"@pershing/ice-notificationcenter": "7.0.0",
	"@pershing/nxp-workbook-common": "14.7.9",
	"@pershing/nxp-memo-adjust": "2.0.0",
	"@pershing/netxwealth-branding": "24.0320.1",
	"@pershing/nxp-aum": "5.3.0",
	"@pershing/nxp-commissionsummary": "3.5.2",
	"@pershing/nxp-markettools": "14.0.2",
	"@pershing/pbo-primeconnect": "0.1.26",
	"@pershing/ifa-libs": "0.5.7",
	"@pershing/nxp-exception-monitor": "8.4.1",
	"@pershing/nxp-notes": "2024.3.2",
	"@pershing/ibd-off-ip": "0.0.2",
	"@pershing/trading-equity-app": "2024.4.20",
	"@pershing/buyins": "10.2023.3",
	"@pershing/netx-ng-groups": "1.7.9",
	"@pershing/nxp-adminapps": "14.0.1",
	"@pershing/companionapps-components": "14.5.12",
	"@pershing/nxp-common-components": "14.1.1",
	"@pershing/olb-ui-ws": "6.7.0",
	"@pershing/wealthapps-config": "14.5.0",
	"@pershing/nxp-quotetrack": "6.0.4",
	"@pershing/nxp-loansmortgages": "4.1.1",
	"@pershing/trading-alternative-investment-app": "2024.4.20",
	"@pershing/nxp-workbook-orderstatus": "6.0.1",
	"@pershing/mfn-roa-config": "1.0.2",
	"@pershing/nxp-preferredstocks": "4.2.4",
	"@pershing/trading-order-status-app": "2024.4.20",
	"@pershing/nxp-freetrialadmin": "24.3.1",
	"@pershing/dashboard-portlets": "2.9.0",
	"@pershing/nxp-enterpriseallocationsystem": "1.0.0",
	"@pershing/cwf-workstatus": "R1.9.62",
	"@pershing/doi-esign": "2024.02.05-DOI",
	"@pershing/admin-stmts": "0.3.1",
	"@pershing/ees-advance-search": "2.0.15",
	"@pershing/nxp-navigation": "14.3.6",
	"@pershing/nxp-gainloss": "7.9.6",
	"@pershing/nxp-ficenter": "2.3.2",
	"@pershing/nxp-portal-netx360wealth": "14.7.6",
	"@pershing/ees-opportunities": "9.0.10",
	"@pershing/nxp-rateboard": "11.0.4",
	"@pershing/nxp-persona": "14.1.1",
	"@pershing/nxp-advancedsearch": "13.5.0",
	"@pershing/trading-common": "2024.4.20",
	"@pershing/ifa-dashboard": "1.4.4",
	"@pershing/workbook-overview": "2.6.0",
	"@pershing/nxp-portal-menu-config": "1.2.5",
	"@pershing/wf-portlet-ng": "R0.0.27",
	"@pershing/nxp-pcb": "7.4.1",
	"@pershing/nxp-mgp-admin": "14.0.2",
	"@pershing/nxp-pcf": "11.5.2",
	"@pershing/nxp-portal-common": "14.7.6",
	"@pershing/ees-core": "0.0.2",
	"@pershing/nxp-companionapp-portal": "14.5.12",
	"@pershing/nxp-downloadupgrade": "5.3.4",
	"@pershing/nxp-portal-components": "14.5.3",
	"@pershing/pershing-common": "14.3.16",
	"@pershing/nxp-balances": "12.7.6",
	"@pershing/nxp-commissioncalculator": "3.5.1",
	"@pershing/nxp-positions": "9.6.2",
	"@pershing/asset-movement-lib": "0.1.13",
	"@pershing/doi-documents": "2024.4.21",
	"@pershing/nds-relationshiptree": "0.0.10",
	"@pershing/nxp-annuity": "3.0.8",
	"@pershing/nxp-bluesky": "6.0.1",
	"@pershing/ice-subscriptions": "8.0.0",
	"@pershing/pershing-grid2": "14.3.16",
	"@pershing/plc-locator": "0.0.75",
	"@pershing/nxp-f2": "2.2.0"
};
var packages = {
	nxiPackages: nxiPackages,
	nxpPackages: nxpPackages
};

var nxiSettings = {
	qaSettings: {
		agGridEnterpriseKey: "Using_this_AG_Grid_Enterprise_key_( AG-044919 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( The Bank of New York Mellon Corporation )_is_granted_a_( Multiple Applications )_Developer_License_for_( 103 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 9 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 27 July 2024 )____[v2]_MTcyMjAzNDgwMDAwMA==89bd30271e6644cab1ea14eb1e81e9ff",
		domainUrl: "https://qa-netxinvestor.bnymellon.net",
		refreshInterval: 4,
		ibdConfigMap: {
			modApiUrl: "https://api-netxselect.wsodqa.com",
			community: "netxinvestor",
			IBD: "511",
			ibdname: "Global Customers Demo",
			ibdTechSupportPhone: "",
			ibdCustSupportEmail: "",
			ibdCustSupportPhone: "",
			HomePage: "/",
			pershingBrandingPath: "staticartifacts/@pershing/mfe-branding@",
			brandsVersion: "24.0918.2",
			cdnURL: "https://xat-www.pllcfiles.inautix.com",
			dasfDomain: "https://qa-netxinvestor.bnymellon.net",
			modernAccountService: true
		},
		platform: "retail",
		region: "test",
		space: "qa",
		cdnAttributes: {
			cdnPath: "https://qa-www.pllcfiles.inautix.com/staticartifacts",
			cdnSeparator: "@",
			artifacts: {
			}
		},
		ampContext: {
			accountNumbers: [
			],
			accountProfiles: [
			],
			assetMovementType: "ach",
			platform: "retail",
			themeType: "modern"
		},
		deviceType: "desktop",
		language: "en",
		locale: "en_US",
		entitlementJson: [
			"STOCK_TRADING",
			"OPTIONS_TRADING",
			"MUTUAL_FUND_TRADING",
			"XTND_HOURS",
			"STOP_LIMIT_TRADING",
			"DELAYED_EQUITY_QUOTES",
			"STOP_OPTION_ORDER",
			"HISTORIC_DATA",
			"PERSHING_WATCHLIST",
			"HISTORIC_DOCS",
			"TURBO_TAX",
			"HR_BLOCK",
			"FINRA_INVESTOR_RESOURCES",
			"PATH_TO_INVESTING",
			"SEC_INVESTOR_EDUCATION",
			"FINRA_CALCULATOR",
			"COMMISION_CALCULATOR",
			"COMMISSION_SCHEDULE",
			"FINANCIAL_ADVISOR",
			"INV_MANAGER_AND_STYLE",
			"MOBILE",
			"SP_RESEARCH",
			"SOLICITED_ORDER_INDICATOR",
			"ORDER_PROSPECTUS",
			"FIXED_INCOME_SEARCH",
			"ACCOUNT_PROFILE",
			"EDIT_DEFAULT_REINVESTMENT",
			"MANAGE_DISPOSTION_METHOD",
			"TAX_GUIDE",
			"ACCOPEN_IBD_TEST",
			"ACCOUNT_SUMMARY",
			"ACCOUNT_SUMMARY_1",
			"ACCOUNT_GROUP",
			"TRADING_529_FUND",
			"MOD_MARKETS",
			"MOD_QUOTES_NEWS",
			"MOD_TOOLS",
			"MOD_ETF_SCREENER",
			"MOD_BRONZE",
			"RATEBOARD",
			"MOD_STOCK_SCREENER",
			"MOD_MUTUAL_FUND_SCREENER",
			"ORDER_STATUS",
			"ALERTS",
			"ALERTS_TRADE",
			"ALERTS_ACTIVITY",
			"ALERTS_MARGIN",
			"ALERTS_POSITIONS_SUMMARY",
			"ASSET_ALLOCATION_ALERTS",
			"CASH_FLOW",
			"E_DOCUMENTS",
			"ELECTRONIC_NOTIFICATION",
			"TAX_STATEMENTS",
			"NOTIFICATIONS",
			"STATEMENTS",
			"HISTORY",
			"COMPOSITION",
			"EQUITY_SECTOR",
			"EQUITY_TYPE",
			"VALUATION_OVER_TIME",
			"INTRADAY_BALANCES_NAVIGATION",
			"BALANCES",
			"DAY_TRADING_BUYING_POWER",
			"ACCOUNT_OPENING",
			"HOLDINGS",
			"BILLSUITE",
			"OVERVIEW_DAY_CHANGE",
			"LIABILITIES_BALANCE",
			"ASSET_TRANSFER_MASTER",
			"FUNDS_TRANSFER",
			"ACCOUNT_PROFILE_UPDATE",
			"FOREIGN_ADDRESS_UPDATE",
			"ADD_NEW_STANDING_INSTRUCTION",
			"REQUEST_A_CHECK",
			"MANAGED_ACCOUNTS_WITHDRAWALS",
			"MANAGED_ACCOUNTS_DEPOSITS",
			"FOREIGN_CURRENCY_DISPLAY",
			"GAIN_LOSS",
			"REALIZED_GAIN_LOSS",
			"LOCKWOOD_DPRS_MNG_PERFORM",
			"LOCKWOOD_QPRS_MNG_PERFORM",
			"LOCKWOOD_QPRS_PMAS",
			"OVERVIEW_UGL",
			"HOUSEHOLD_PROFILE",
			"CUSTOM_ASSET_CLASSIFICTION",
			"MAG_ACCT_PROFILE",
			"ADVISOR_GROUP_PERFORMANCE",
			"DOWNLOAD_FORMS",
			"CONTACT_BROKERAGE",
			"ABOUT_US",
			"FREQUENTLY_ASKED_QUESTIONS",
			"NXI_MOBILE_CHECK_DEPOSIT_REMITPRO",
			"SHARED_DOCUMENT_ALERTS",
			"MUTUAL_FUND_INCOME_PROJECTIONS",
			"BIOMETRIC_AUTHENTICATION",
			"MUTUAL_FUND_SELL_BUYNG",
			"WARNING_MESSAGE_DISPLAY",
			"NXI_FINANCIAL_PLANNING_ACCESS",
			"VIEW_TAX_RECLAIM_RECEIVABLES",
			"PORTFOLIO_MOVERS",
			"POST_LOGIN_MSGS",
			"DISPLAY_SETTINGS",
			"MESSAGE_CENTER",
			"RESEARCH_PAGE",
			"MARKETS_PAGE",
			"QUOTES_NEWS_PAGE",
			"INVESTING_TOOLS_PAGE",
			"RATEBOARD_PAGE",
			"PORTFOLIOPLUS"
		],
		entitlementJsonObject: ""
	},
	xatSettings: {
		agGridEnterpriseKey: "Using_this_AG_Grid_Enterprise_key_( AG-044919 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( The Bank of New York Mellon Corporation )_is_granted_a_( Multiple Applications )_Developer_License_for_( 103 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 9 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 27 July 2024 )____[v2]_MTcyMjAzNDgwMDAwMA==89bd30271e6644cab1ea14eb1e81e9ff",
		domainUrl: "https://xat-netxinvestor.bnymellon.com",
		refreshInterval: 4,
		ibdConfigMap: {
			modApiUrl: "https://api-netxselect.wsodqa.com",
			community: "netxinvestor",
			IBD: "511",
			ibdname: "Global Customers Demo",
			ibdTechSupportPhone: "",
			ibdCustSupportEmail: "",
			ibdCustSupportPhone: "",
			HomePage: "/",
			pershingBrandingPath: "staticartifacts/@pershing/mfe-branding@",
			brandsVersion: "24.0918.2",
			cdnURL: "https://xat-www.pllcfiles.inautix.com",
			dasfDomain: "https://xat-netxinvestor.bnymellon.com",
			modernAccountService: true
		},
		platform: "retail",
		region: "qa",
		space: "xat",
		cdnAttributes: {
			cdnPath: "https://xat-www.pllcfiles.inautix.com/staticartifacts",
			cdnSeparator: "@",
			artifacts: {
			}
		},
		ampContext: {
			accountNumbers: [
			],
			accountProfiles: [
			],
			assetMovementType: "ach",
			platform: "retail",
			themeType: "modern"
		},
		deviceType: "desktop",
		language: "en",
		locale: "en_US",
		entitlementJson: [
			"STOCK_TRADING",
			"OPTIONS_TRADING",
			"MUTUAL_FUND_TRADING",
			"XTND_HOURS",
			"STOP_LIMIT_TRADING",
			"DELAYED_EQUITY_QUOTES",
			"STOP_OPTION_ORDER",
			"HISTORIC_DATA",
			"PERSHING_WATCHLIST",
			"HISTORIC_DOCS",
			"TURBO_TAX",
			"HR_BLOCK",
			"FINRA_INVESTOR_RESOURCES",
			"PATH_TO_INVESTING",
			"SEC_INVESTOR_EDUCATION",
			"FINRA_CALCULATOR",
			"COMMISION_CALCULATOR",
			"COMMISSION_SCHEDULE",
			"FINANCIAL_ADVISOR",
			"INV_MANAGER_AND_STYLE",
			"MOBILE",
			"SP_RESEARCH",
			"SOLICITED_ORDER_INDICATOR",
			"ORDER_PROSPECTUS",
			"FIXED_INCOME_SEARCH",
			"ACCOUNT_PROFILE",
			"EDIT_DEFAULT_REINVESTMENT",
			"MANAGE_DISPOSTION_METHOD",
			"TAX_GUIDE",
			"ACCOPEN_IBD_TEST",
			"ACCOUNT_SUMMARY",
			"ACCOUNT_SUMMARY_1",
			"ACCOUNT_GROUP",
			"TRADING_529_FUND",
			"MOD_MARKETS",
			"MOD_QUOTES_NEWS",
			"MOD_TOOLS",
			"MOD_ETF_SCREENER",
			"MOD_BRONZE",
			"RATEBOARD",
			"MOD_STOCK_SCREENER",
			"MOD_MUTUAL_FUND_SCREENER",
			"ORDER_STATUS",
			"ALERTS",
			"ALERTS_TRADE",
			"ALERTS_ACTIVITY",
			"ALERTS_MARGIN",
			"ALERTS_POSITIONS_SUMMARY",
			"ASSET_ALLOCATION_ALERTS",
			"CASH_FLOW",
			"E_DOCUMENTS",
			"ELECTRONIC_NOTIFICATION",
			"TAX_STATEMENTS",
			"NOTIFICATIONS",
			"STATEMENTS",
			"HISTORY",
			"COMPOSITION",
			"EQUITY_SECTOR",
			"EQUITY_TYPE",
			"VALUATION_OVER_TIME",
			"INTRADAY_BALANCES_NAVIGATION",
			"BALANCES",
			"DAY_TRADING_BUYING_POWER",
			"ACCOUNT_OPENING",
			"HOLDINGS",
			"BILLSUITE",
			"OVERVIEW_DAY_CHANGE",
			"LIABILITIES_BALANCE",
			"ASSET_TRANSFER_MASTER",
			"FUNDS_TRANSFER",
			"ACCOUNT_PROFILE_UPDATE",
			"FOREIGN_ADDRESS_UPDATE",
			"ADD_NEW_STANDING_INSTRUCTION",
			"REQUEST_A_CHECK",
			"MANAGED_ACCOUNTS_WITHDRAWALS",
			"MANAGED_ACCOUNTS_DEPOSITS",
			"FOREIGN_CURRENCY_DISPLAY",
			"GAIN_LOSS",
			"REALIZED_GAIN_LOSS",
			"LOCKWOOD_DPRS_MNG_PERFORM",
			"LOCKWOOD_QPRS_MNG_PERFORM",
			"LOCKWOOD_QPRS_PMAS",
			"OVERVIEW_UGL",
			"HOUSEHOLD_PROFILE",
			"CUSTOM_ASSET_CLASSIFICTION",
			"MAG_ACCT_PROFILE",
			"ADVISOR_GROUP_PERFORMANCE",
			"DOWNLOAD_FORMS",
			"CONTACT_BROKERAGE",
			"ABOUT_US",
			"FREQUENTLY_ASKED_QUESTIONS",
			"NXI_MOBILE_CHECK_DEPOSIT_REMITPRO",
			"SHARED_DOCUMENT_ALERTS",
			"MUTUAL_FUND_INCOME_PROJECTIONS",
			"BIOMETRIC_AUTHENTICATION",
			"MUTUAL_FUND_SELL_BUYNG",
			"WARNING_MESSAGE_DISPLAY",
			"NXI_FINANCIAL_PLANNING_ACCESS",
			"VIEW_TAX_RECLAIM_RECEIVABLES",
			"PORTFOLIO_MOVERS",
			"POST_LOGIN_MSGS",
			"DISPLAY_SETTINGS",
			"MESSAGE_CENTER",
			"RESEARCH_PAGE",
			"MARKETS_PAGE",
			"QUOTES_NEWS_PAGE",
			"INVESTING_TOOLS_PAGE",
			"RATEBOARD_PAGE",
			"PORTFOLIOPLUS"
		],
		entitlementJsonObject: ""
	},
	prodSettings: {
		agGridEnterpriseKey: "Using_this_AG_Grid_Enterprise_key_( AG-044919 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( The Bank of New York Mellon Corporation )_is_granted_a_( Multiple Applications )_Developer_License_for_( 103 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 9 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 27 July 2024 )____[v2]_MTcyMjAzNDgwMDAwMA==89bd30271e6644cab1ea14eb1e81e9ff",
		domainUrl: "https://www.netxinvestor.com",
		refreshInterval: 4,
		ibdConfigMap: {
			modApiUrl: "https://api-netxselect.wallst.com",
			community: "netxinvestor",
			IBD: "511",
			ibdname: "Global Customers Demo",
			ibdTechSupportPhone: "",
			ibdCustSupportEmail: "",
			ibdCustSupportPhone: "",
			HomePage: "/",
			pershingBrandingPath: "staticartifacts/@pershing/mfe-branding@",
			brandsVersion: "24.0918.2",
			cdnURL: "https://www.pllcfiles.com",
			dasfDomain: "https://www.netxinvestor.com",
			modernAccountService: true
		},
		platform: "retail",
		region: "prod",
		space: "",
		cdnAttributes: {
			cdnPath: "https://www.pllcfiles.com/staticartifacts",
			cdnSeparator: "@",
			artifacts: {
			}
		},
		ampContext: {
			accountNumbers: [
			],
			accountProfiles: [
			],
			assetMovementType: "ach",
			platform: "retail",
			themeType: "modern"
		},
		deviceType: "desktop",
		language: "en",
		locale: "en_US",
		entitlementJson: [
		],
		entitlementJsonObject: "{}"
	}
};
var nxpSettings = {
	qaSettings: {
		appData: {
			subsessionid: "",
			appName: "MAO"
		},
		appContext: {
		},
		domainUrl: "https://qa-www2.netx360.inautix.com",
		region: "dev",
		isForPortal: false,
		space: "dev",
		routeStrategy: "service-discovery",
		entitlementJsonObject: "{}",
		platform: "professional",
		platformType: "wealth",
		cdnAttributes: {
			cdnPath: "https://qa-www.pllcfiles.inautix.com/staticartifacts",
			cdnSeparator: "@",
			artifacts: {
			}
		},
		theme: "compact",
		agGridEnterpriseKey: "CompanyName=SHI International Corp_on_behalf_of_Pershing LLC,LicensedGroup=PERSHING-AG-GRID,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=65,LicensedProductionInstancesCount=5,AssetReference=AG-017559,ExpiryDate=28_July_2022_[v2]_MTY1ODk2MjgwMDAwMA==3733e30adc6e71242b1dea0b6f4ae6c7"
	},
	xatSettings: {
		domainUrl: "https://xat-www2.netx360.inautix.com",
		appData: {
			subsessionid: "",
			appName: "MAO"
		},
		appContext: {
		},
		region: "qa",
		isForPortal: false,
		space: "xat",
		routeStrategy: "service-discovery",
		entitlementJsonObject: "{}",
		platform: "professional",
		platformType: "wealth",
		cdnAttributes: {
			cdnPath: "https://xat-www.pllcfiles.inautix.com/staticartifacts",
			cdnSeparator: "@",
			artifacts: {
			}
		},
		theme: "compact",
		agGridEnterpriseKey: "CompanyName=SHI International Corp_on_behalf_of_Pershing LLC,LicensedGroup=PERSHING-AG-GRID,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=65,LicensedProductionInstancesCount=5,AssetReference=AG-017559,ExpiryDate=28_July_2022_[v2]_MTY1ODk2MjgwMDAwMA==3733e30adc6e71242b1dea0b6f4ae6c7"
	},
	prodSettings: {
		domainUrl: "https://www2.netx360.com",
		appData: {
			subsessionid: "",
			appName: "MAO"
		},
		appContext: {
		},
		region: "prod",
		isForPortal: false,
		space: null,
		routeStrategy: "service-discovery",
		entitlementJsonObject: "{}",
		platform: "professional",
		platformType: "wealth",
		cdnAttributes: {
			cdnPath: "https://www.pllcfiles.com/staticartifacts",
			cdnSeparator: "@",
			artifacts: {
			}
		},
		theme: "compact",
		agGridEnterpriseKey: "CompanyName=SHI International Corp_on_behalf_of_Pershing LLC,LicensedGroup=PERSHING-AG-GRID,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=65,LicensedProductionInstancesCount=5,AssetReference=AG-017559,ExpiryDate=28_July_2022_[v2]_MTY1ODk2MjgwMDAwMA==3733e30adc6e71242b1dea0b6f4ae6c7"
	}
};
var settings = {
	nxiSettings: nxiSettings,
	nxpSettings: nxpSettings
};

/**
 * State Object for the service and MFE portal that stores and communicates data between the various MFE components.
 * The state object contains the following:
 * appSettings -- general application settings for the overall MFE shell.
 * userId -- the username or identifier of the user logged in
 * pershingJWT -- the current DASF JWT token for use in communication with Pershing servers from outside the Pershing domain.
 * currentAccount -- the current account selected by the user for which to display information, defaulting to ALL accounts in none is specified.
 */
class State {
    /**
     * The appSettings object within the state object contains important configuration for the portal as a whole. It has the following settings:
     * home -- the relative url path to be used as the 'home' of the application. Users will be redirected to this path after logging in.
     * logout -- the relative url path to be used as the 'logout' screen of the application. Users will be redirected here after logging out.
     * refreshInterval -- the interval between invocations of the keepAlive event being emitted. 10 minutes by default but can be changed to any value
     * between 1 and 15 minutes(exclusive) if desired. Periods longer than 15 minutes are not supported.
     */
    appSettings = {
        home: '',
        logout: '',
        refreshInterval: 4,
        cdnAttributes: {}
    };
    userId = '';
    pershingJWT = '';
    ibd = '';
}
class StorageService {
    getItem(key) {
        return sessionStorage.getItem(key);
    }
    setItem(key, data) {
        sessionStorage.setItem(key, data);
    }
    clear() {
        sessionStorage.clear();
    }
    removeItem(key) {
        sessionStorage.removeItem(key);
    }
    hasItem(key) {
        return sessionStorage.getItem(key) ? true : false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StorageService, providedIn: "platform" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "platform"
                }]
        }] });

class PerNgPlatformService {
    storageService;
    //Internal variables
    _platformState = new State();
    baseURL = "";
    refreshJWTTimer;
    pershingJWTtoken = '';
    _state = 'STATE';
    domainURL = "";
    restURL = "";
    currentAccount = { domain: 'account', value: new AccountContextValue("ALL") };
    ibd = "";
    platform = "";
    acctList = [];
    // subscription subjects
    /**
     * The service has 4 subscribable objects that can be leveraged for sharing information across MFEs:
     * userLoggedIn$ -- keeps track of whether or not the user is logged in.
     * goToPage$ -- Triggered by the public goToPage() method and indicates where an MFE should navigate to.
     * currentState$ -- Emitted every time state changes, allowing stage propogation to all MFEs subscribed.
     * currentAccount$ -- Emitted when the current account is changed. This subscribale is intended to be used to minimize the need to parse state
     * for a value that is expected to be commonly changed as a user utilizes available services.
     */
    _userLoggedIn = new BehaviorSubject(false);
    userLoggedIn$ = this._userLoggedIn.asObservable();
    _goToPage = new BehaviorSubject('');
    goToPage$ = this._goToPage.asObservable();
    _currentState = new BehaviorSubject(this._platformState);
    currentState$ = this._currentState.asObservable();
    _currentAccount = new BehaviorSubject(this.currentAccount);
    currentAccount$ = this._currentAccount.asObservable();
    _accountList = new BehaviorSubject(this.acctList);
    accountList$ = this._accountList.asObservable();
    /*Provides an HttpClient for the service. Dependency injection is explicitly NOT used to ensure a singleton instance of the service
    in all MFEs and the platform shell.
    */
    injector = Injector.create({
        providers: [
            { provide: HttpClient, deps: [HttpHandler] },
            { provide: HttpHandler, useValue: new HttpXhrBackend({ build: () => new XMLHttpRequest }) },
        ],
    });
    _httpClient = this.injector.get(HttpClient);
    /**
     * Constructor for the service. The constructor checks to see if there is a state object already set in the session storage.
     * If there is, it is read, parsed as JSON and the platform state is updated to reflect it. Additionally, values for the specialized
     * subscribers are checked for and updated as appropriate.
     */
    constructor(storageService) {
        this.storageService = storageService;
        console.debug("Constructing Platform Setting");
        const state = this.storageService.getItem(this._state);
        if (!!state) {
            this._platformState = JSON.parse(state);
            this._currentState.next(this._platformState);
            if (this._platformState.pershingJWT) {
                this.pershingJWTtoken = this._platformState.pershingJWT;
            }
        }
    }
    initializeApp() {
        return new Promise((resolve) => {
            console.debug("*** Platform Service added ***");
            resolve();
        });
    }
    /**
     * Sets the home page in the platform state. Used to redirect after login.
     * @param portalHomePage The relative url of the homepage to display for a logged in user.
     */
    setHome(portalHomePage) {
        this._platformState.appSettings.home = portalHomePage;
        this._currentState.next(this._platformState);
    }
    /**
     * Gets the home page in the platform state.
     * @returns String of the relative url of the home page.
     */
    getHomePage() {
        return this._platformState.appSettings.home;
    }
    /**
     * Sets the logout page in the platform state. Used to redirect after logout.
     * @param logoutPage The relative url of the page to display upon logout.
     */
    setLogoutPage(logoutPage) {
        this._platformState.appSettings.logout = logoutPage;
        this._currentState.next(this._platformState);
    }
    /**
     * Gets the logout page in the platform state.
     * @returns String of the relative url of the logout page.
     */
    getLogoutPage() {
        return this._platformState.appSettings.logout;
    }
    /**
     * Sets the application settings in the platform state.
     * @param appSettings An objecet containing the application settings to be shared across the service.
     */
    setAppSettings(appSettings) {
        this._platformState.appSettings = appSettings;
        this._currentState.next(this._platformState);
    }
    /**
     * Gets the appSettings object in the platform state.
     * @returns appSettings object from the platform state.
     */
    getAppSettings() {
        return this._platformState.appSettings;
    }
    /**
     * Sets up the baseline configurations needed for MFEs to run in the designated environment for the designated IBD.
     * @param platform which platform to load. Appropriate options are professional and retail.
     * @param environment which environment to load for, options are qa, xat, or prod. Defaults to prod if default is needed.
     * @param ibd The ibd ID for the client. Check with Pershing team for value if needed.
     * @param ibdname Optional: sets the text name of the IBD.
     * @param homepage Optional: Sets a homepage redirect. If set the end of the login process will trigger an update of goToPage$
     * @param device Optional: Sets the device type. Is useful for ensuring proper display on device types. If not set, Desktop will be assumed.
     */
    init(platform, environment, ibd, ibdname, homepage, device) {
        if (platform === "retail" || platform === "professional") {
            this.platform = platform;
        }
        else {
            return "PERMFE017";
        }
        if (this.platform === "retail") {
            if (ibd && ibd != "") {
                this.ibd = ibd;
            }
            else {
                return "PERMFE018";
            }
            return this.initNXI(environment, this.ibd, settings.nxiSettings, ibdname, homepage, device);
        }
        else if (this.platform === "professional") {
            return this.init360(environment, settings.nxpSettings);
        }
        return ("PERMFE019");
    }
    initNXI(environment, ibd, settings, ibdname, homepage, device) {
        let appSettings;
        if (environment === "qa") {
            appSettings = settings.qaSettings;
            this.restURL = "/test-netxinvestor-rest-service-qa-app/services/netxclient.rest-service";
        }
        else if (environment === "xat") {
            appSettings = settings.xatSettings;
            this.restURL = "/qa-netxinvestor-rest-service-xat-app/services/netxclient.rest-service";
        }
        else {
            appSettings = settings.prodSettings;
            this.restURL = "/netxinvestor-rest-service-app/services/netxclient.rest-service";
        }
        appSettings.ibdConfigMap.IBD = ibd.toUpperCase();
        this.ibd = ibd.toUpperCase();
        appSettings.cdnAttributes.artifacts = packages.nxiPackages;
        this.baseURL = appSettings.ibdConfigMap.dasfDomain;
        this.domainURL = appSettings.domainUrl;
        if (ibdname) {
            appSettings.ibdConfigMap.ibdname = ibdname;
        }
        ;
        if (homepage) {
            appSettings.ibdConfigMap.HomePage = homepage;
        }
        if (device) {
            appSettings.deviceType = device;
        }
        window.pershingAppSettings = appSettings;
        window.appSettings = appSettings;
        window.appSettings.entitlementJsonObject = JSON.stringify({ "response": { "permissions": window.appSettings.entitlementJson } });
        this.setAppSettings(appSettings);
        return ("PERMFE001");
    }
    init360(environment, settings) {
        let appSettings;
        if (environment === "qa") {
            appSettings = settings.qaSettings;
        }
        else if (environment === "xat") {
            appSettings = settings.xatSettings;
        }
        else {
            appSettings = settings.prodSettings;
        }
        appSettings.cdnAttributes.artifacts = packages.nxpPackages;
        this.domainURL = appSettings.domainUrl;
        this.baseURL = appSettings.domainUrl;
        window.pershingAppSettings = appSettings;
        window.appSettings = appSettings;
        this.setAppSettings(appSettings);
        return ("PERMFE001");
    }
    /**
     * Sets customer support phone number and email and tech support phone number for the IBD.
     * @param techSupportPhone Optional string.
     * @param custSupportPhone Optional string.
     * @param custSupportEmail Optional string.
     */
    setIbdInfo(techSupportPhone, custSupportPhone, custSupportEmail) {
        let appSettings = this.getAppSettings();
        if (techSupportPhone) {
            appSettings.ibdConfigMap.ibdTechSupportPhone = techSupportPhone;
        }
        if (custSupportPhone) {
            appSettings.ibdConfigMap.ibdCustSupportPhone = custSupportPhone;
        }
        if (custSupportEmail) {
            appSettings.ibdConfigMap.ibdCustSupportEmail = custSupportEmail;
        }
        window.pershingAppSettings = appSettings;
        window.appSettings = appSettings;
        this.setAppSettings(appSettings);
    }
    ;
    /**
     * Sets the userId field in the platform state.
     * @param userId string of the UserId or SubscribedId.
     */
    setUserId(userId) {
        this._platformState.userId = (userId + '').toUpperCase();
        this._userLoggedIn.next(true);
        this._currentState.next(this._platformState);
    }
    /**
     * Gets the userId in the platform state.
     * @returns string of the UserId or SubscriberId
     */
    getUserId() {
        return this._platformState.userId || '';
    }
    /**
     * Allows for changing the context without the use of the account dropdown selector. Requires inputting the value and the domain. Currently only functions for the Account and Group domain.
     * @param value The value to be changed to as a string. Should be either an Account Number, or a Group ID, without the username prefix.
     * @param domain The domain type for the new context. Currently accepts either account or group. If no value is provided, will default to account.
     */
    setContext(value, domain) {
        let dom = domain ?? 'account';
        let newContext = new DomainContext();
        if (dom.toLowerCase() === 'account' && value != "") {
            newContext.domain = 'account';
            newContext.value = this.createAccountContext(value);
        }
        if (dom.toLowerCase() === 'group' && value != "") {
            newContext.domain = 'group';
            newContext.value = this.createGroupContext(value);
        }
        if (newContext.domain != undefined && newContext.value != undefined) {
            this.currentAccount = newContext;
            this._currentAccount.next(newContext);
            let contextChangedEvent = new CustomEvent("CONTEXT_UPDATE", {
                detail: newContext,
                bubbles: true
            });
            console.debug("DISPATCH EVENT WITH VALUE", contextChangedEvent);
            window.dispatchEvent(contextChangedEvent);
        }
        else {
            console.error("Invalid Context Input");
        }
    }
    createAccountContext(value) {
        let newAccountValue;
        let foundAccount = this.unhashAccount(value);
        if ((typeof foundAccount) === 'object') {
            newAccountValue = new AccountContextValue(foundAccount.acctNo);
            newAccountValue.ibd = this.ibd;
            newAccountValue.hashValue = foundAccount.acctReference;
            newAccountValue.accountType = foundAccount.acctTypeCode;
            newAccountValue.managerName = foundAccount.managerName;
            newAccountValue.investmentStyle = foundAccount.investmentStyle;
            newAccountValue.acctNick = foundAccount.acctNick;
        }
        else {
            newAccountValue = new AccountContextValue(value);
        }
        return newAccountValue;
    }
    createGroupContext(value) {
        let newGroupValue;
        let foundAccount = this.unhashAccount(value);
        if ((typeof foundAccount) === "object") {
            newGroupValue = new GroupContextValue(foundAccount.groupId);
            newGroupValue.hashValue = foundAccount.acctReference;
            newGroupValue.groupType = foundAccount.acctTypeCode;
            if (foundAccount.acctNo == "ALL") {
                newGroupValue.GUID = this.ibd + "_" + foundAccount.groupId + "_C";
            }
            else {
                newGroupValue.GUID = this.ibd + "_" + foundAccount.groupId + "_" + (!!newGroupValue.groupType ? newGroupValue.groupType : 'C');
            }
        }
        else {
            newGroupValue = new GroupContextValue(value);
        }
        return newGroupValue;
    }
    /**
     * Obtain the current context.
     * @returns The currently set context.
     */
    getAccount() {
        return this.currentAccount;
    }
    /**
     * Check the logged in status.
     * @returns Boolean value for whether the user is logged in or not, as determined by whether or not a user ID has been set in the platform state.
     */
    isUserLoggedIn() {
        if (this._platformState.userId !== '')
            return true;
        return false;
    }
    /**
   * Notifies the portal to navigate to a specified page.
   * @param page String for the page name to navigate to.
   */
    goToPage(page) {
        this._goToPage.next(page);
    }
    /**
     * Function communicates with DASF to verify a client JWT token. If the token is valid a Pershing JWT token will be provided and stored to
     * facilitate access to Pershing resources. A keep alive timer/event will also be set to maintain token validity, and should correspond with the
     * expiration policy of the client JWT token.
     * @param subscriberId A string container the userId or SubscriberId of the user.
     * @param clientJWTToken A client generated token that is sent to DASF for verification. Every remote host will need one.
     * @param tcAccepted Input from the client indicating whether the Pershing Terms and Conditions have been accepted. Login will fail if false.
     * @returns "Internal Login Successful" | "Login Successful" | "Invalid ID" | "No redirect found" | "Login failed. Terms and Conditions Must Be Accepted." | DASF Error
     */
    async login(subscriberId, clientJWTToken) {
        subscriberId = subscriberId.toUpperCase();
        if (subscriberId == '') {
            return "PERMFE020";
        }
        if (!clientJWTToken) {
            let response = this.localLogin(subscriberId);
            return response;
        }
        if (clientJWTToken) {
            let response = this.remoteLogin(subscriberId, clientJWTToken);
            return response;
        }
        return "PERMFE019";
    }
    async localLogin(subscriberId) {
        this.setUserId(subscriberId);
        this.storageService.setItem(this._state, JSON.stringify(this._platformState));
        if (this._platformState.appSettings.home !== '') {
            this.goToPage(this._platformState.appSettings.home);
        }
        return "PERMFE003";
    }
    async remoteLogin(subscriberId, clientJWTToken) {
        const httpOptions = {
            headers: new HttpHeaders({
                'client-JWT-Assertion': clientJWTToken
            })
        };
        try {
            const response = await lastValueFrom(this._httpClient.post(this.baseURL + EventConstants.DASF_JWT_URL, '', httpOptions));
            if (response[EventConstants.DASF_STATUS] === "0") {
                let token = response['pershingJWT'];
                this._platformState.pershingJWT = token;
                this.pershingJWTtoken = token;
                this.setUserId(subscriberId);
                this._userLoggedIn.next(true);
                this.storageService.setItem(this._state, JSON.stringify(this._platformState));
                this.initiateJwtRefreshTimer();
                if (window.pershingAppSettings.platform == "retail") {
                    this.fetchAccountList();
                    this.getNXIUserEntitlements();
                }
                if (this._platformState.appSettings.home !== '') {
                    this.goToPage(this._platformState.appSettings.home);
                    return "PERMFE003";
                }
                else {
                    return "PERMFE003";
                }
            }
            return "DASF code: " + response[EventConstants.DASF_STATUS];
        }
        catch (error) {
            console.error(error);
            return "DASF error " + error;
        }
    }
    /**
     * Handles cleaning up platform and session states as part of the logout process. Clears the session.
     * If a JWT token is present, will also terminate the JWT token locally and with DASF.
     * @returns True for successful logout or false if logout fails for any reason. Session storage will be cleared in either instance.
     */
    async logout() {
        console.debug("Logout started");
        let islogoutSuccess = false;
        try {
            // Throw an error if Pershing JWT is null, empty, undefined
            if (!this._platformState.pershingJWT)
                throw new Error('Pershing JWT is required');
            // Construct the JWT header
            const httpOptions = {
                headers: new HttpHeaders({
                    'X-JWT-Assertion': this._platformState.pershingJWT
                })
            };
            // Wait for the HTTP operation to complete
            console.debug("Invoke logout");
            const resp = await lastValueFrom(this._httpClient.post(this.baseURL + EventConstants.DASF_LOGOUT_URL, '', httpOptions));
            console.debug("Logout response", resp);
            islogoutSuccess = true;
        }
        catch (error) {
            console.error("Logout error", error);
            islogoutSuccess = false;
        }
        finally {
            // Clear the Pershing Session
            console.debug("Clearing session");
            this.clearSession();
            console.debug("Session cleared");
        }
        // Return the logout operation flag
        console.debug("Return logout flag", islogoutSuccess);
        return islogoutSuccess;
    }
    /**
     * First step in the refresh token process. Called from an event listener. Expects an updated/refreshed client token.
     * @param newClientToken A new client token to be verified to refresh the Pershing JWT token and keep the dasf authorization alive. Can be triggered by client code
     * directly or as a response to the keep alive timer even set by the login method ('refreshJWTToken' dispatched by the window)
     */
    async refreshJWT(newClientToken) {
        let callRefresh = false;
        await this.keepAlive().then(data => {
            callRefresh = data;
        });
        if (callRefresh) {
            this.refreshJWTToken(newClientToken);
        }
        else {
            this.clearSession();
        }
    }
    /**
     * Second step in the refresh token process, called from refreshJWT. Calls the DASF keepalive endpoint with the current pershingJWTtoken.
     * @returns Promise<Boolean> which resolves to true or false based on the outcome of DASF keepalive call.
     */
    async keepAlive() {
        const httpOptions = {
            headers: new HttpHeaders({
                "X-JWT-Assertion": this.pershingJWTtoken
            })
        };
        return await lastValueFrom(this._httpClient.post(this.baseURL + EventConstants.DASF_KEEPALIVE_URL, '', httpOptions))
            .then((_response) => {
            return true;
        }, error => {
            return false;
        });
    }
    /**
     * Upon successful retrieval of the first pershingJWTtoken, will create a timer and attach it to the window to dispatch a refreshJWTToken event at the interval
     * set in appSettings on the platform state. By default this is every 10 minutes but may be configured for different timing.
     */
    initiateJwtRefreshTimer() {
        function timer() {
            let interval = setInterval(function () {
                postMessage("REFRESH");
                console.debug("DISPATCH REFRESH AT " + Date.now());
            }, 4 * 60000);
        }
        let code = timer.toString();
        code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
        let blob = new Blob([code], { type: "application/javascript" });
        let blobUrl = window.URL.createObjectURL(blob);
        if (typeof (Worker) !== "undefined" && !this.refreshJWTTimer) {
            this.refreshJWTTimer = new Worker(blobUrl);
            this.refreshJWTTimer.addEventListener('message', () => { window.dispatchEvent(new CustomEvent('refreshJWTToken')); }, false);
            this.refreshJWTTimer.postMessage('1');
            window.URL.revokeObjectURL(blobUrl);
        }
    }
    /**
     * Final step of the refresh process. Exchanges a stale JWT token for a fresh one when called.
     * @param clientJWTToken A client token generated by the client's application.
     */
    refreshJWTToken(clientJWTToken) {
        const oldJwtToken = this.pershingJWTtoken;
        const httpOptions = {
            headers: new HttpHeaders({
                'client-JWT-Assertion': clientJWTToken,
                'X-JWT-Assertion': oldJwtToken
            })
        };
        lastValueFrom(this._httpClient.post(this.baseURL + EventConstants.DASF_JWT_REFRESH_URL, '', httpOptions))
            .then((response) => {
            if (response[EventConstants.DASF_STATUS] === '0') {
                this._platformState.pershingJWT = response[EventConstants.DASF_JWT_TOKEN];
                this.pershingJWTtoken = response['pershingJWT'];
                this.storageService.setItem(this._state, JSON.stringify(this._platformState));
            }
            else {
                this.clearSession();
            }
        }, error => {
            this.clearSession();
        });
    }
    /**
     * Called as part of the logout process. Removes the JWT token and removes all session information.
     */
    clearSession() {
        this._platformState.userId = '';
        if (this._platformState.pershingJWT) {
            this._platformState.pershingJWT = "";
            this.pershingJWTtoken = "";
        }
        this._userLoggedIn.next(false);
        this.storageService.removeItem(this._state);
        console.debug("Storage cleared");
        if (this.refreshJWTTimer) {
            this.refreshJWTTimer.terminate();
            console.debug("JWT Timer terminated");
        }
        if (this._platformState.appSettings.logout !== '') {
            this.goToPage(this._platformState.appSettings.logout);
        }
    }
    async getNXIUserEntitlements() {
        const domainUrl = this.appSettings.domainUrl;
        const region = this.appSettings.region === 'prod' ? '' : this.appSettings.region;
        const space = this.appSettings.space;
        const uri = 'miscservice/getUserEntitlements';
        const family = 'netxinvestor';
        const appName = 'miscellaneous-svc';
        const serviceName = 'app';
        const servicePath = [region, family, appName, space, serviceName].filter((value) => { return value; }).join('-');
        let serviceUrl = [servicePath, uri].filter((value) => { return value; }).join('/');
        serviceUrl = `${domainUrl}/${serviceUrl}`;
        try {
            const data = await this.getLastValueFrom(this._httpClient.get(serviceUrl, {
                headers: new HttpHeaders({
                    'X-JWT-Assertion': this.pershingJWTtoken
                })
            }));
            if (typeof data !== 'undefined' && data.response !== undefined &&
                data.response.permissions !== undefined &&
                data.response.permissions.length !== undefined) {
                this.appSettings.entitlementJsonObject = JSON.stringify(data);
                this.appSettings.entitlementJson = data.response.permissions;
            }
            else {
                console.error("Error fetching user entitlements");
                this.appSettings.entitlementJsonObject = "";
                this.appSettings.entitlementJson = [];
            }
        }
        catch (error) {
            console.error("Error fetching user entitlements");
            this.appSettings.entitlementJsonObject = "";
            this.appSettings.entitlementJson = [];
        }
    }
    async fetchAccountList() {
        const httpOptions = {
            headers: new HttpHeaders({
                'X-JWT-Assertion': this.pershingJWTtoken
            })
        };
        let url = this.appSettings.region + "-netxinvestor-miscellaneous-svc-" + this.appSettings.space + "-app/subscriberAccounts/getPortfolioAccounts";
        try {
            const resp = await this.getLastValueFrom(this._httpClient.get(this.domainURL + "/" + url, httpOptions));
            if (resp) {
                this.acctList = resp;
                this._accountList.next(resp);
            }
            else {
                this.acctList = [];
            }
        }
        catch (error) {
            this.acctList = [];
        }
    }
    // Wrapper method for lastValueFrom
    getLastValueFrom(source$) {
        return lastValueFrom(source$);
    }
    get appSettings() {
        return window.pershingAppSettings;
    }
    // Getter for acctList
    /**
     *
     * @returns The current account list.
     */
    getAcctList() {
        return this.acctList;
    }
    // Setter for acctList
    /**
     *
     * @param value The account list to be set.
     */
    setAcctList(value) {
        this.acctList = value;
    }
    unhashAccount(acct) {
        if (this.acctList.length > 0) {
            let foundObject = this.acctList.find(account => new RegExp('^' + account.acctNo + '$|^' + account.acctReference + '$|^' + account.groupDesc + '$').test(acct));
            if (foundObject) {
                return foundObject;
            }
            else {
                return "Account or Group not found";
            }
        }
        else {
            return "Account list not loaded";
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PerNgPlatformService, deps: [{ token: StorageService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PerNgPlatformService, providedIn: 'platform' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PerNgPlatformService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: function () { return [{ type: StorageService }]; } });

const CURRENT_STATE = 'STATE';
const TOKEN_NAME = 'pershingJWT';
const DISABLE_JWT_HEADER = 'DISABLE-JWT';
const JWT_AUTH_HEADER = 'X-JWT-Assertion';

class JwtInterceptor {
    storage;
    constructor(storage) {
        this.storage = storage;
    }
    isAuthRequired(url) {
        let appSettings = window.pershingAppSettings;
        let authRequired = false;
        let authRequiredDomains = new Array();
        if (appSettings) {
            if (appSettings.domainUrl) {
                authRequiredDomains.push(appSettings.domainUrl);
            }
            if (appSettings.additionalAuthHeaderDomains && appSettings.additionalAuthHeaderDomains.length > 0) {
                authRequiredDomains = authRequiredDomains.concat(appSettings.additionalAuthHeaderDomains);
            }
        }
        for (let index = 0; index < authRequiredDomains.length; index++) {
            let domain = authRequiredDomains[index];
            if (url.indexOf(domain) > -1) {
                authRequired = true;
                break;
            }
        }
        return authRequired;
    }
    intercept(request, next) {
        if (this.isAuthRequired(request.url)) {
            // Check if DISABLE-JWT header is found
            if (request.headers.has(DISABLE_JWT_HEADER)) {
                // Delete only that header. HttpHeaders is immutable
                const headers = request.headers.delete(DISABLE_JWT_HEADER);
                // Clone the request since HttpRequest objects are immutable
                request = request.clone({ headers });
            }
            else {
                const current_state_str = this.storage.getItem(CURRENT_STATE);
                if (!!current_state_str) {
                    const current_state = JSON.parse(current_state_str);
                    const currentToken = current_state[TOKEN_NAME];
                    if (!!currentToken) {
                        // Clone the request since HttpRequest objects are immutable
                        request = request.clone({
                            headers: request.headers.set(JWT_AUTH_HEADER, currentToken)
                        });
                    }
                }
            }
        }
        // Pass the modified request to the next interceptor or the HTTP handler
        return next.handle(request);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: JwtInterceptor, deps: [{ token: StorageService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: JwtInterceptor });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: JwtInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: StorageService }]; } });

/**
 * Override the CDK Overlay container
 * Add the 'per-mfe-ns' namespace class
 * Refer: https://github.com/angular/components/blob/main/src/cdk/overlay/overlay-container.ts#L48
 */
class CustomOverlayContainer extends OverlayContainer {
    _createContainer() {
        const containerClass = 'cdk-overlay-container';
        const mfeNamespaceClass = 'per-mfe-ns';
        // TODO(crisbeto): remove the testing check once we have an overlay testing
        // module or Angular starts tearing down the testing `NgModule`. See:
        // https://github.com/angular/angular/issues/18831
        if (this._platform.isBrowser || _isTestEnvironment()) {
            const oppositePlatformContainers = this._document.querySelectorAll(`.${containerClass}[platform="server"], ` + `.${containerClass}[platform="test"]`);
            // Remove any old containers from the opposite platform.
            // This can happen when transitioning from the server to the client.
            for (let i = 0; i < oppositePlatformContainers.length; i++) {
                oppositePlatformContainers[i].remove();
            }
        }
        const mfecontainer = this._document.createElement('div');
        mfecontainer.classList.add(mfeNamespaceClass);
        const container = this._document.createElement('div');
        container.classList.add(containerClass);
        // A long time ago we kept adding new overlay containers whenever a new app was instantiated,
        // but at some point we added logic which clears the duplicate ones in order to avoid leaks.
        // The new logic was a little too aggressive since it was breaking some legitimate use cases.
        // To mitigate the problem we made it so that only containers from a different platform are
        // cleared, but the side-effect was that people started depending on the overly-aggressive
        // logic to clean up their tests for them. Until we can introduce an overlay-specific testing
        // module which does the cleanup, we try to detect that we're in a test environment and we
        // always clear the container. See #17006.
        // TODO(crisbeto): remove the test environment check once we have an overlay testing module.
        if (_isTestEnvironment()) {
            container.setAttribute('platform', 'test');
        }
        else if (!this._platform.isBrowser) {
            container.setAttribute('platform', 'server');
        }
        mfecontainer.appendChild(container);
        this._document.body.appendChild(mfecontainer);
        this._containerElement = container;
    }
}

const PERSHING_PLATFORM_SERVICES = [
    PerNgPlatformService
];
function initApp(platformService) {
    return () => platformService.initializeApp();
}
const PERSHING_PLATFORM_SERVICE_PROVIDERS = [
    ...PERSHING_PLATFORM_SERVICES,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: initApp, deps: [PerNgPlatformService], multi: true },
    { provide: OverlayContainer, useClass: CustomOverlayContainer }
];
class PerNgPlatformServiceModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PerNgPlatformServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PerNgPlatformServiceModule, imports: [CommonModule,
            HttpClientModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PerNgPlatformServiceModule, providers: [
            ...PERSHING_PLATFORM_SERVICE_PROVIDERS
        ], imports: [CommonModule,
            HttpClientModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PerNgPlatformServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule
                    ],
                    providers: [
                        ...PERSHING_PLATFORM_SERVICE_PROVIDERS
                    ]
                }]
        }] });

/*
 * Public API Surface of per-ng-platform-service
 */

/**
 * Generated bundle index. Do not edit.
 */

export { JwtInterceptor, PERSHING_PLATFORM_SERVICE_PROVIDERS, PerNgPlatformService, PerNgPlatformServiceModule, initApp };
